import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { SIMPLModal } from '../dialog/SIMPLModal';
import { SIMPLButtonCustomized } from '../button/SIMPLButtonCustumized';
import { SIMPLInputTextCustumized } from '../input/SIMPLInputTextCustumized';

interface CredentialLinkModalProps {
  link: string;
  onCancel: () => void;
  onCopied: () => void;
  onCopyError: () => void;
}

export const CredentialLinkModal: React.FC<CredentialLinkModalProps> = ({
  link,
  onCancel,
  onCopied,
  onCopyError,
}) => {
  const { t } = useTranslation();
  const [isLinkVisible, setIsLinkVisible] = useState<boolean>(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      onCopied();
    } catch {
      onCopyError();
    }
  };

  const actions = (
    <div className="flex items-center gap-3 -mr-4">
      <SIMPLButtonCustomized
        label={t('Cancel')}
        secondary
        buttonHandlerAction={onCancel}
        testId="credential-link-cancel"
      />
      <SIMPLButtonCustomized
        label={t('Copy')}
        primary
        buttonHandlerAction={handleCopy}
        testId="credential-link-copy"
      />
    </div>
  );

  return (
    <SIMPLModal
      title={t('CredentialsLink')}
      onClose={onCancel}
      actions={actions}
      testId="credential-link-modal"
    >
      <div className="relative [&_input]:px-2 [&_input:hover]:border-[#B0B3BA]">
        <SIMPLInputTextCustumized
          id="credential-link-value"
          name="credentialLink"
          type={isLinkVisible ? 'text' : 'password'}
          value={link}
          onChange={() => undefined}
          label={t('Link')}
          required
          readOnly
        />
        <button
          type="button"
          className="absolute right-3 bottom-2"
          onClick={() => setIsLinkVisible((prev) => !prev)}
          aria-label={isLinkVisible ? t('HideLink') : t('ShowLink')}
          data-test-id="credential-link-toggle-visibility"
        >
          {isLinkVisible ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
        </button>
      </div>
    </SIMPLModal>
  );
};
